import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const getClientById = clientId => {
  const query = `
    query ($clientId: ID!){
        clients(clientId: $clientId){
           nodes{
                id
                name
                status
                logo
                code
                countryId
                isSelfServeEnabled
                apiAccessEnabled
                isTaxExemptionEnabled
                isAffiliate
                isSkipCheckoutEnabled
                addressVerificationEnabled
                addressVerificationDailyBudget
                addressVerificationMonthlyBudget
                createdBy
                sftpEnabled
                tags{
                    id
                    value
                    type
                    tagLinkId
                    }
           }
        }
       getTags(type: CLIENT){
            edges {
                 node {
                    id
                    value
                    type
                 }
            }
       }
       getClientTaxExemptionByState(clientId: $clientId){
                   id
                   clientId
                   stateCode
                   name
                   deletedAt
                   uploadedBy
                   url
                   createdAt
       }
    }
  `
  const params = { clientId }
  return callAuthorizedGraphQLEndpoint(query, params)
}

export { getClientById }
